import { useMutation } from '@tanstack/react-query';
import {
  BaseResponseEntity,
  SubmitReferralDto,
  UserWalletAuthService,
} from 'services/openapi';

export const useSubmitRefferalMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BaseResponseEntity, Error, SubmitReferralDto>({
      mutationFn: (variables: SubmitReferralDto) => {
        return UserWalletAuthService.authControllerSubmitReferralId(variables);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
